import { render, staticRenderFns } from "./IdentificationCheck.vue?vue&type=template&id=4ad7df74&scoped=true"
import script from "./IdentificationCheck.vue?vue&type=script&lang=js"
export * from "./IdentificationCheck.vue?vue&type=script&lang=js"
import style0 from "./IdentificationCheck.vue?vue&type=style&index=0&id=4ad7df74&prod&scoped=true&lang=css"
import style1 from "./IdentificationCheck.vue?vue&type=style&index=1&id=4ad7df74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7df74",
  null
  
)

export default component.exports